var _excluded = ["children", "value", "onChange", "borderRadius", "compact", "name", "buttonType"],
  _excluded2 = ["label", "value", "selected", "disabled", "onClick", "borderRadius", "buttonType", "primary"];
var _templateObject, _templateObject2;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import { jsxs as F, jsx as b } from "react/jsx-runtime";
import { Children as y, isValidElement as x, cloneElement as g } from "react";
import { styled as $, css as A } from "styled-components";
var E = $.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  background: ", ";\n  border-radius: ", ";\n  width: fit-content;\n  ", ";\n"])), function (_ref) {
    var e = _ref.theme;
    return e.colors.blue95;
  }, function (_ref2) {
    var e = _ref2.$borderRadius;
    return "".concat(e, "px");
  }, function (_ref3) {
    var e = _ref3.$compact;
    return !e && A(["display:grid;grid-auto-flow:column;grid-auto-columns:1fr;"]);
  }),
  V = function V(_ref4) {
    var e = _ref4.children,
      i = _ref4.value,
      s = _ref4.onChange,
      _ref4$borderRadius = _ref4.borderRadius,
      n = _ref4$borderRadius === void 0 ? 8 : _ref4$borderRadius,
      _ref4$compact = _ref4.compact,
      f = _ref4$compact === void 0 ? !0 : _ref4$compact,
      _ref4$name = _ref4.name,
      a = _ref4$name === void 0 ? "filters" : _ref4$name,
      r = _ref4.buttonType,
      o = _objectWithoutProperties(_ref4, _excluded);
    var l = I({
      value: i,
      children: e,
      onChange: s,
      borderRadius: n,
      name: a,
      buttonType: r
    });
    return /* @__PURE__ */F(E, _objectSpread(_objectSpread({
      $borderRadius: n,
      $compact: f,
      role: "group"
    }, o), {}, {
      children: [/* @__PURE__ */b("input", {
        type: "hidden",
        name: a,
        value: i
      }), l]
    }));
  },
  I = function I(_ref5) {
    var e = _ref5.value,
      i = _ref5.children,
      s = _ref5.onChange,
      n = _ref5.borderRadius,
      f = _ref5.name,
      a = _ref5.buttonType;
    var r = [];
    var o = y.toArray(i).map(function (t) {
        if (! /*#__PURE__*/x(t)) throw new Error("Filters contains an unexpected child");
        return t.props.value;
      }),
      l = Array.isArray(e),
      d = [];
    return y.forEach(i, function (t) {
      /*#__PURE__*/x(t) && t.props.primary && d.push(t.props.value);
    }), y.map(i, function (t) {
      if (! /*#__PURE__*/x(t) || t.type.displayName !== "Filter") throw new Error("Filters contains an unexpected child");
      var m = (l ? e : [e]).includes(t.props.value);
      m && (l ? r.push(t.props.value) : r = [t.props.value]);
      var w = function w(p) {
        if (l) {
          r = r.filter(function (c) {
            return !d.includes(c);
          }), t.props.primary ? r = [p] : r.includes(p) ? new Set(r).size > 1 && (r = r.filter(function (c) {
            return c !== p;
          })) : r.push(p);
          var u = r.length === o.length - d.length ? d : r;
          s == null || s(u);
        } else s == null || s(p);
      };
      return /*#__PURE__*/g(t, _objectSpread(_objectSpread({
        buttonType: a || "button"
      }, t.props), {}, {
        selected: m,
        onClick: !m || l ? w : void 0,
        borderRadius: n,
        onKeyDown: function onKeyDown(p) {
          if (t.props.disabled || !s) return;
          var u = o.findIndex(function (k) {
            return k === e;
          });
          var c;
          p.code === "ArrowLeft" ? c = u === 0 ? o[o.length - 1] : o[u - 1] : p.code === "ArrowRight" ? c = u === o.length - 1 ? o[0] : o[u + 1] : c = e, s == null || s(c);
        }
      }));
    });
  },
  h = $.button(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  flex-flow: column;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n  outline: none;\n  border: none;\n  cursor: pointer;\n  user-select: none;\n  appearance: none;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  text-align: center;\n  padding: 8px 16px;\n  color: ", ";\n  height: fit-content;\n  white-space: nowrap;\n  font-family: inherit;\n\n  &[aria-pressed='true'] {\n    color: ", ";\n    background: ", ";\n    border-radius: ", ";\n  }\n\n  &&:hover:enabled {\n    &[aria-pressed='false'] {\n      color: ", ";\n    }\n  }\n\n  &:disabled {\n    color: ", ";\n    cursor: unset;\n  }\n"])), function (_ref6) {
    var e = _ref6.theme;
    return e.colors.blue50;
  }, function (_ref7) {
    var e = _ref7.theme;
    return e.colors.black100;
  }, function (_ref8) {
    var e = _ref8.theme;
    return e.colors.blue60;
  }, function (_ref9) {
    var e = _ref9.$borderRadius;
    return "".concat(e, "px");
  }, function (_ref10) {
    var e = _ref10.theme;
    return e.colors.blue30;
  }, function (_ref11) {
    var e = _ref11.theme;
    return e.colors.black60;
  }),
  j = function j(_ref12) {
    var e = _ref12.label,
      i = _ref12.value,
      _ref12$selected = _ref12.selected,
      s = _ref12$selected === void 0 ? !1 : _ref12$selected,
      _ref12$disabled = _ref12.disabled,
      n = _ref12$disabled === void 0 ? !1 : _ref12$disabled,
      f = _ref12.onClick,
      _ref12$borderRadius = _ref12.borderRadius,
      a = _ref12$borderRadius === void 0 ? 8 : _ref12$borderRadius,
      r = _ref12.buttonType,
      _ref12$primary = _ref12.primary,
      o = _ref12$primary === void 0 ? !1 : _ref12$primary,
      l = _objectWithoutProperties(_ref12, _excluded2);
    return /* @__PURE__ */b(h, _objectSpread(_objectSpread(_objectSpread({
      "aria-pressed": s,
      tabIndex: s ? -1 : 0,
      onClick: function onClick() {
        !n && f && f(i);
      },
      $borderRadius: a,
      type: r
    }, n ? {
      disabled: n
    } : void 0), l), {}, {
      children: e
    }));
  };
j.displayName = "Filter";
export { j as Filter, V as Filters };